"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataIcon = void 0;
const core_1 = require("@material-ui/core");
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const camelCase_1 = __importDefault(require("lodash/camelCase"));
const react_1 = __importDefault(require("react"));
const AvatarIcon_1 = __importDefault(require("../icons/AvatarIcon"));
const IndustryIcon_1 = __importDefault(require("../icons/IndustryIcon"));
const OpDefinitionIcon_1 = __importDefault(require("../icons/OpDefinitionIcon"));
const OrganisationIcon_1 = __importDefault(require("../icons/OrganisationIcon"));
const PlaceIcon_1 = __importDefault(require("../icons/PlaceIcon"));
const PositionIcon_1 = __importDefault(require("../icons/PositionIcon"));
const QuestionSetIcon_1 = __importDefault(require("../icons/QuestionSetIcon"));
const TeamIcon_1 = __importDefault(require("../icons/TeamIcon"));
const TemplateIcon_1 = __importDefault(require("../icons/TemplateIcon"));
const backgroundColors = {
    [DataType_1.default.TEAM]: lib_palette_1.default.OJ.main,
    [DataType_1.default.PLACE]: lib_palette_1.default.MediumSeaGreen.main,
    [DataType_1.default.POSITION]: lib_palette_1.default.Indigo.main,
    [DataType_1.default.STAFF]: lib_palette_1.default.MediumBlue.main,
    [DataType_1.default.ORGANISATION]: lib_palette_1.default.Liquorice.main,
    [DataType_1.default.OPDEFINITION]: lib_palette_1.default.TimelineRed.main,
    [DataType_1.default.TEMPLATE]: lib_palette_1.default.TimelineRed.main,
    [DataType_1.default.QUESTIONSET]: lib_palette_1.default.TimelineRed.main,
    [DataType_1.default.ORGTEMPLATE]: lib_palette_1.default.TimelineRed.main,
    [DataType_1.default.INDUSTRY]: lib_palette_1.default.NicerGreen.main,
};
const makeMyClasses = (size, style, safeType) => ({
    main: Object.assign(Object.assign({ width: `${size}px !important`, height: `${size}px !important`, borderRadius: '50%' }, (style || {})), { '&.MuiAvatar-colorDefault': {
            color: lib_palette_1.default.White.main,
            backgroundColor: `${backgroundColors[safeType]} !important`,
        } }),
    bg: {
        backgroundColor: `${backgroundColors[safeType]} !important`,
    },
});
function DataIcon(props) {
    const { showBackground = true, type, avatarUrl, size = 26, margin = 4, style } = props;
    let iconBit;
    const iconProps = {
        size: size - margin * 2,
        style: { margin },
        color: lib_palette_1.default.White,
    };
    const safeType = (0, camelCase_1.default)(type || '');
    const myCss = (0, web_css_1.default)(makeMyClasses, [size, style, safeType]);
    switch (safeType) {
        case DataType_1.default.TEAM:
            iconBit = react_1.default.createElement(TeamIcon_1.default, Object.assign({}, iconProps));
            break;
        case DataType_1.default.PLACE:
            iconBit = react_1.default.createElement(PlaceIcon_1.default, Object.assign({}, iconProps));
            break;
        case DataType_1.default.POSITION:
            iconBit = react_1.default.createElement(PositionIcon_1.default, Object.assign({}, iconProps));
            break;
        case DataType_1.default.STAFF:
            iconBit = react_1.default.createElement(AvatarIcon_1.default, Object.assign({}, iconProps));
            break;
        case DataType_1.default.ORGANISATION:
            iconBit = react_1.default.createElement(OrganisationIcon_1.default, Object.assign({}, iconProps));
            break;
        case DataType_1.default.OPDEFINITION:
            iconBit = react_1.default.createElement(OpDefinitionIcon_1.default, Object.assign({}, iconProps));
            break;
        case DataType_1.default.TEMPLATE:
        case DataType_1.default.ORGTEMPLATE:
            iconBit = react_1.default.createElement(TemplateIcon_1.default, Object.assign({}, iconProps));
            break;
        case DataType_1.default.INDUSTRY:
            iconBit = react_1.default.createElement(IndustryIcon_1.default, Object.assign({}, iconProps));
            break;
        case DataType_1.default.QUESTIONSET:
            iconBit = react_1.default.createElement(QuestionSetIcon_1.default, Object.assign({}, iconProps));
            break;
    }
    if (!iconBit && !avatarUrl)
        return null;
    if (avatarUrl) {
        return react_1.default.createElement(core_1.Avatar, { src: avatarUrl, classes: { root: myCss.main } });
    }
    if (showBackground) {
        return react_1.default.createElement("div", { className: myCss.main + ' ' + myCss.bg }, iconBit);
    }
    else {
        return iconBit;
    }
}
exports.DataIcon = DataIcon;
exports.default = DataIcon;
